const gridColumn = {
  gc2 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 6',
    lg: 'span 6',
    xl: 'span 2',
  },
  gc3 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 6',
    lg: 'span 6',
    xl: 'span 3',
  },
  gc4 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 6',
    lg: 'span 4',
    xl: 'span 4',
  },
  gc6 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 6',
    lg: 'span 6',
    xl: 'span 6',
  },
  gc8 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 8',
    lg: 'span 8',
    xl: 'span 8',
  },
  gc10 : {
    base: 'span 10',
    sm: 'span 10',
    md: 'span 10',
    lg: 'span 10',
    xl: 'span 10',
  },
  gc12 : {
    base: 'span 12',
    sm: 'span 12',
    md: 'span 12',
    lg: 'span 12',
    xl: 'span 12',
  }
}


export { gridColumn };
